import type { HubConnection } from '@microsoft/signalr';

export async function notifyTaskChange(hub: HubConnection, userId: string, operationId: string) {
    try { await hub.invoke('SendChange', userId, operationId); }
    catch (error) {
        // Only an explicitly unsupported method permits fallback. A lost reply may already have broadcast.
        if (error instanceof Error && /(?:method (?:does not exist|not found)|unknown hub method)/i.test(error.message)) {
            await hub.invoke('Send', userId);
        } else throw error;
    }
}
